'use client';

import { c as _c } from "react/compiler-runtime";
import RefreshIcon from '@mui/icons-material/Refresh';
import WarningIcon from '@mui/icons-material/Warning';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import { Modal } from '@shared/components/Modal';
import { type ReactNode, startTransition, useEffect, useState } from 'react';
interface VersionSyncProps {
  appVersion: string;
  children(isANewVersion: boolean): ReactNode;
}
export const VersionSync: React.FC<VersionSyncProps> = t0 => {
  const $ = _c(22);
  const {
    children,
    appVersion
  } = t0;
  const [isANewVersion, setIsANewVersion] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showInfoAlert, setShowInfoAlert] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setShowWarningModal(false);
      setShowInfoAlert(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onCloseModal = t1;
  let t2;
  let t3;
  if ($[1] !== appVersion) {
    t2 = () => {
      const eventSource = new EventSource("/api/version");
      eventSource.onmessage = event => {
        const serverVersion = JSON.parse(event.data).version;
        const clientVersion = appVersion;
        if (serverVersion === clientVersion) {
          return;
        }
        setShowWarningModal(true);
      };
      return () => {
        eventSource.close();
      };
    };
    t3 = [appVersion];
    $[1] = appVersion;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] !== appVersion) {
    t4 = () => {
      const localStorageVersion = localStorage.getItem("version");
      if (localStorageVersion !== appVersion) {
        if (localStorageVersion) {
          startTransition(() => {
            setIsANewVersion(true);
          });
        }
        localStorage.setItem("version", appVersion);
      }
    };
    t5 = [appVersion];
    $[4] = appVersion;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      position: "fixed",
      bottom: 20,
      right: 20
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Alert severity="warning" action={<Button color="inherit" size="small" onClick={_temp} startIcon={<RefreshIcon />}>Reload</Button>}><Typography variant="body2">A new version is available. Please save your work and reload the page.</Typography></Alert>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== showInfoAlert) {
    t8 = <Collapse in={showInfoAlert} sx={t6}>{t7}</Collapse>;
    $[9] = showInfoAlert;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = Boolean(showWarningModal && !showInfoAlert);
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <><Button color="primary" onClick={onCloseModal}>Close</Button><Button onClick={_temp2} color="primary" variant="contained">Reload</Button></>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Box display="flex" alignItems="center"><WarningIcon color="warning" sx={{
        mr: 2
      }} /><Typography>A new version of this application is available. To ensure the best experience, please save your work and reload the page. Thank you for your understanding.</Typography></Box>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t9) {
    t12 = <Modal title="New Version Available" isOpen={t9} onClose={onCloseModal} disableClose={false} withCancelButton={false} actions={t10}>{t11}</Modal>;
    $[13] = t9;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== children || $[16] !== isANewVersion) {
    t13 = children(isANewVersion);
    $[15] = children;
    $[16] = isANewVersion;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t12 || $[19] !== t13 || $[20] !== t8) {
    t14 = <>{t8}{t12}{t13}</>;
    $[18] = t12;
    $[19] = t13;
    $[20] = t8;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  return t14;
};
function _temp() {
  return window.location.reload();
}
function _temp2() {
  return window.location.reload();
}